import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import SnResizableUND from "@shared/components/SnResizableUND";
import SnAgGrid from "@shared/components/Grid/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnButton from "@shared/components/SnButton";
import { showPopupModal } from "@widgets/CommonModal";
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통
import EXC000000000029005_POP_001 from "@menu/XTC/EXC000000000029005/EXC000000000029005_POP_001";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const EXC000000000029005 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridApiRefH = useRef<any>(null);
  const gridApiRefL = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns1, setColums] = useState<ColumnConfig[]>([]);

  const [columns2, setColums2] = useState<any[]>([]);

  const [dataSource1, setDataSource1] = useState<any[]>([]); // 초기값을 빈 배열로 설정
  const [dataSource2, setDataSource2] = useState<any>();

  const today = new Date();

  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;

  const { userInfo } = global();

  const cd_menu = Menuprops.cd_menu || "EXC000000000029005";
  const defaultSize = { panel1height: "49.5%", panel2height: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums(rtn.grid.grid1);
        setColums2(rtn.grid.grid2);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridApiRefH.current.getChange();
    const modifiedRowsL = gridApiRefL.current.getChange();
    const selectedFormData = searchRef.current.getFormdata();
    if (selectedFormData.dt_from > selectedFormData.dt_to) {
      showDialog(
        "alter",
        " 조회기간의 종료일이 시작일보다빠릅니다.확인 후 다시 조회해주시기 바랍니다."
      );
      return;
    }
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const checkSave: any = await onSave();
        if (!checkSave) {
          return;
        }
      }
    }
    try {
      const p = {
        ...searchRef.current.getFormdata(),
        g_cd_firm: userInfo.cd_firm,
        g_cd_cust: userInfo.cd_cust || "",
      };
      const param = {
        id: "exc000000000029005_01",
        params: p,
      };
      setDataSource1([]);
      setDataSource2([]);
      const data: any = await fnGetDataSet(param);

      setDataSource1(data[0]);
      setDataSource2(data[1]);

      if (data[0] && data[0].length > 0) {
        const selectNoso = data[0][0];

        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridApiRefH.current.selectAndFocusRow(0);
      }

      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const mtlAssetreqhChanges = gridApiRefH.current.getChange().insert;

      if (mtlAssetreqhChanges.length > 0) return false;

      const searchFormData = searchRef.current.getFormdata();

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        dt_req: todayform,
        cd_cust: "",
        cd_cust_new: "",
        tp_req: "CUST",
        st_req: "P",
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onInsert = async () => {
    try {
      const newRow = {}; // 빈 객체
      gridApiRefH.current?.addRow(newRow);
    } catch (error: any) {}
  };
  //On Delete
  const onDelete = async () => {
    const gridApiH = gridApiRefH.current.api;
    const rowCount = gridApiH.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return;
    }

    gridApiRefL.current?.deleteAllRows();
    gridApiRefH.current?.deleteSelectedRows();

    const realDeletedRows = gridApiRefH.current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
      return;
    }

    await onSave();
  };

  const onBeforeAddRowL = (newRow: RowData): boolean => {
    try {
      // gridH가 선택되지 않았을 경우 리턴
      if (
        !gridApiRefH ||
        gridApiRefH.current.api.getSelectedNodes().length === 0
      ) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      const selectedRows = gridApiRefH.current.api.getSelectedNodes();
      const searcontrols = searchRef.current.getFormdata();

      const gridApiL = gridApiRefL.current.api;
      const rowCount = gridApiL ? gridApiL.getDisplayedRowCount() : 0;
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        no_line: rowCount + 1,
        no_req: selectedRows[0].data?.no_req,
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false; // cd_cust 값이 없는 행이 있으면 종료
    }
  };
  //On AddRow
  const onAddRow = async () => {
    try {
      const newRow = {}; // 빈 객체
      gridApiRefL.current?.addRow(newRow);
    } catch (error: any) {}
  };
  //On DeleteRow
  const onDeleteRow = async () => {
    const gridApil = gridApiRefL.current.api;
    const rowCount = gridApil.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }

    gridApiRefL.current?.deleteSelectedRows();
  };

  const onSave = async () => {
    let mtlAssetreqhChanges;
    let mtlAssetreqlChanges;
    const getRenderedNodes = gridApiRefL.current.api.getRenderedNodes();
    try {
      // H 필수값 체크
      const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      // L 필수값 체크
      const requiredValuesCheckL = gridApiRefL.current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      mtlAssetreqhChanges = gridApiRefH.current.getChange();
      mtlAssetreqlChanges = gridApiRefL.current.getChange();
      const headerInserts = mtlAssetreqhChanges.insert ?? [];
      const lineInserts = mtlAssetreqlChanges.insert ?? [];
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog("alter", "저장에 실패했습니다.");
        return;
      }
      if (
        mtlAssetreqhChanges.modifiedRowcount === 0 &&
        mtlAssetreqlChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      //신규 등록된 수주건이 있는 경우 채번
      for (let row of headerInserts) {
        if (!row.no_req) {
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;
          try {
            const no_slip = await getNoSlip(
              cd_module,
              27,
              "MAR",
              row.dt_req,
              cd_menu
            );

            if (no_slip) {
              row.no_req = no_slip; // no_req 값을 추가

              const gridApiH = gridApiRefH.current.api;
              const focusedCell = gridApiH.getFocusedCell();
              if (focusedCell) {
                const rowNode = gridApiH.getDisplayedRowAtIndex(
                  focusedCell.rowIndex
                );
                rowNode.setDataValue("no_req", no_slip);
              }

              for (let row of lineInserts) {
                if (!row.no_req) {
                  if (no_slip) {
                    row.no_req = no_slip; // no_req 값을 추가
                  }
                }
              }
            }
          } catch (error) {}
        }
      }
      // 요청 데이터 구성

      const SaveData = {
        mtl_asset_changereqh: mtlAssetreqhChanges,
        mtl_asset_changereql: mtlAssetreqlChanges,
      };

      // 저장 API 호출
      await fnSave("EXC000000000029005_SAVE_01", SaveData);

      // 성공적으로 저장된 후 초기화
      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
      return true;
    } catch (error: any) {
      // 저장 실패 시 삭제된 데이터 복구
      if (mtlAssetreqhChanges.delete?.length > 0) {
        gridApiRefL.current.api.applyTransaction({
          add: mtlAssetreqlChanges.delete,
        });
      }

      if (mtlAssetreqhChanges?.delete?.length > 0) {
        const res = gridApiRefH.current.api.applyTransaction({
          add: mtlAssetreqhChanges.delete,
        });

        // 첫 번째 복구된 행 자동 선택 & 포커스 이동
        if (res.add && res.add.length > 0) {
          const firstRestoredRow = res.add[0]; // 첫 번째 복구된 행
          gridApiRefH.current?.selectAndFocusRow(firstRestoredRow.rowIndex);
        }

        // 변경 버퍼 초기화 (Insert / Update / Delete 버퍼 리셋)
        gridApiRefH.current.resetUpdate();
        gridApiRefL.current.resetUpdate();
      }
    }
  };
  //#endregion
  const onGrid2BtnsClick = async (id: string) => {
    if (id == "addRow") {
      onAddRow();
    }
    if (id == "deleteRow") {
      onDeleteRow();
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnApplyasset") {
      const selectedRows = gridApiRefH.current.api.getSelectedNodes();
      const mtlAssetChanges = gridApiRefH.current.getChange().insert;
      if (mtlAssetChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      if (selectedRows[0].data?.cd_cust === "") {
        await showDialog("alter", "거래처은 필수값입니다");
        return;
      }

      if (selectedRows[0].data?.cd_cust_new === "") {
        await showDialog("alter", "변경거래처은 필수값입니다");
        return;
      }

      // searchPanel에서 선택된 값 전달
      // Passing the selected value from searchPanel
      const selectedFormData = searchRef.current.getFormdata();
      const component = <EXC000000000029005_POP_001 />;
      const result = await showPopupModal({
        title: "자산 도움창",
        children: component,
      });
      if (!result || result === "close") return;
      const lineResult: any[] = result[0];

      // 견적도움창 Line 결과 적용
      //apply the results to the line
      lineResult.map((result: any) => {
        onAddRow();
        const rowCount = gridApiRefL.current.api.getDisplayedRowCount();
        const lastRowIndex = rowCount - 1;

        // 마지막 행에 대한 rowNode를 가져오기
        const lastRowNode =
          gridApiRefL.current.api.getDisplayedRowAtIndex(lastRowIndex);

        if (lastRowNode) {
          // 추가된 행에 값을 설정
          gridApiRefL.current.setValue(
            lastRowNode,
            "no_asset",
            result.no_asset
          );
          gridApiRefL.current.setValue(
            lastRowNode,
            "cd_asset",
            result.cd_asset
          );
          gridApiRefL.current.setValue(lastRowNode, "nm_item", result.nm_item);

          gridApiRefL.current.setValue(
            lastRowNode,
            "dc_item_spec",
            result.dc_item_spec
          );
          gridApiRefL.current.setValue(lastRowNode, "no_pur", result.no_pur);
        }
      });
    }
  };

  const onCellValueChangedH = async (event: any) => {
    if (!event) return;
    const updatedRow = event.data;
    const gridApiH = gridApiRefH.current.api;
    const updatedColumnId = event.column.getColId();
  };
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const no_req = selectedRow.no_req;
      gridApiRefL.current.applyFilters({ no_req: no_req });
      gridApiRefL.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            
            seq={1}
            ref={gridApiRefH}
            columnConfig={columns1}
            rowData={dataSource1}
            isEditable={true}
            rowSelection="single"
            onBeforeAddRow={onBeforeAddRowH}
            onFocusedRowChanged={onFocusedRowChanged}
            onCellValueChanged={onCellValueChangedH}
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            
            seq={2}
            ref={gridApiRefL}
            columnConfig={columns2}
            rowData={dataSource2}
            enableExternalChart={false}
            isEditable={true}
            rowSelection="multiple"
            onBeforeAddRow={onBeforeAddRowL}
            title="   "
            // onBtnAddClick={onGrid2BtnsClick}
            // onBtnDeleteClick={onGrid2BtnsClick}
            rowDragManaged={true}
            header={
              <div>
                <SnButton
                  text={"자산적용"}
                  onClick={() => {
                    onGrid1BtnsClick("btnApplyasset");
                  }}
                />
              </div>
            }
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
      </div>
    </div>
  );
});

export default EXC000000000029005;
